export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8563.39f0f803.jpg";